import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const SRT_CRO_VIEW = (navigate, fromDate, toDate, projectId) => [
  { field: "name", headerName: "CRO Name", width: 250 },
  { field: "rescheduled_count", headerName: "Total Rescheduled", width: 200 },
  {
    field: "rescheduled_by_parent",
    headerName: "Rescheduled By Parent",
    width: 200,
  },
  {
    field: "rescheduled_by_tutor",
    headerName: "Rescheduled By Tutor",
    width: 200,
  },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            background:
              "linear-gradient(135deg, rgb(62, 72, 106), rgb(134, 105, 241))",
            color: "#fff",
            "&:hover": {
              background:
                "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(62, 108, 177, 0.74))",
            },
            px: "10px",
          }}
          onClick={() => {
            navigate(
              `/my-workspace/srt-studentdetails?fromDate=${fromDate}&toDate=${toDate}&croId=${params.row.croId}&project_id=${projectId}`
            );
          }}
        >
          View Report
        </Button>
      );
    },
  },
];
